
import * as React from "react";
import { IOpeningHours } from "../../interfaces/IRestaurant";
import InputTime from "./InputTime";


interface IChanged{
    (ret:IOpeningHours):void
}

interface IOpeningHoursProps {
    changed              : IChanged
    hideTitleRow        ?:boolean
    openingHours: any
}

interface IOpeningHoursState {
    form: any,
    days: any,
    loading: boolean
}

export default class OpeningHours extends React.Component<IOpeningHoursProps, IOpeningHoursState>{

  	constructor(props:IOpeningHoursProps){
        super(props);


        this.state = {
            form: [],
            days: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            loading: false
        };

    }
    componentDidMount() {
        this.init();
    }


    private init(){
        let form = [];
        Array.from({ length: 7 }, (value, key) => {
            let openingHours = this.props.openingHours.find(hour => hour.week_day == key);
            form.push({
                weekday: key,
                opens_at: openingHours !== undefined ? openingHours.opens_at : '',
                closes_at: openingHours !== undefined ? openingHours.closes_at : '',
            })
        })

        this.setState({
            form: form
        });
    }


    private changeInputHandler(evt, type:string, weekday: number): void {
        evt.preventDefault();
        let form = this.state.form;
        form[weekday][type] = evt.target.value;
        this.setState({
            form: form
        });

        this.refreshForm();
    }

    private refreshForm():void{
          this.props.changed(this.state.form);
    }

    render() {
        return (
            <div className = "opening-hours">
                { this.state.form &&
                    <>
                        {
                            !this.props.hideTitleRow &&
                            <div className="form-row">
                                <div className="col simpletext title-box">Opening hours:</div>
                            </div>

                        }
                        {
                            this.state.form.map((obj, i) => (
                            <div className="form-row" key = {i}>
                                <div className="col-4 simpletext">{this.state.days[i]}</div>
                                <div className="col-4 col_time">
                                    <InputTime
                                        key={'opens_at_'+i}
                                        name={'opens_at_'+i}
                                        value={obj.opens_at}
                                        onChange={ e => this.changeInputHandler(e,'opens_at', i) }
                                    />
                                </div>
                                <div className="col-4 col_time">
                                    <InputTime
                                        key={'closes_at_'+i}
                                        name={'closes_at_'+i}
                                        value={obj.closes_at}
                                        onChange={ e => this.changeInputHandler(e,'closes_at', i) }
                                />
                                </div>
                            </div>
                            ))
                        }
                    </>
                }
            </div>
        );
    }
}
